import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { api } from '../lib/api';
import { useToast } from '../context/ToastContext';
import TelaPublica from '../components/TelaPublica';

// "Esqueci minha senha": pede o e-mail e o servidor manda um link (válido por 1 hora,
// uso único). A resposta é sempre a mesma exista o e-mail ou não — de propósito.
export default function EsqueciSenha() {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  async function enviar(e) {
    e.preventDefault();
    setEnviando(true);
    try {
      const r = await api.post('/auth/esqueci-senha', { email });
      setMensagem(r.message);
    } catch (err) {
      toast.erro(err.message || 'Não foi possível enviar o pedido');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <TelaPublica>
      <h1 className="h5 text-center mb-3">Esqueci minha senha</h1>
      {mensagem ? (
        <Alert variant="success">{mensagem}</Alert>
      ) : (
        <Form onSubmit={enviar}>
          <p className="text-muted small">Informe o e-mail do seu acesso. Enviaremos um link para você criar uma nova senha.</p>
          <Form.Group className="mb-3" controlId="esqueci-email">
            <Form.Label>E-mail</Form.Label>
            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </Form.Group>
          <Button type="submit" variant="primary" className="w-100 text-uppercase fw-bold" disabled={enviando}>
            {enviando ? <Spinner animation="border" size="sm" /> : 'Enviar link'}
          </Button>
        </Form>
      )}
      <div className="text-center mt-3">
        <Link to="/login">Voltar para o login</Link>
      </div>
    </TelaPublica>
  );
}
